import L from "leaflet";

/**
 * `leaflet.heat` und `leaflet.markercluster` (via `react-leaflet-cluster`) sind klassische
 * Leaflet-Plugins, die ein globales `L` erwarten (sie schreiben z.B. `L.HeatLayer = …`,
 * `L.MarkerClusterGroup = …`) und Leaflet NICHT selbst importieren. Im gebündelten
 * ESM-Prod-Build gibt es kein `window.L`, daher crashen sie beim Laden mit
 * "Can't find variable: L" (Safari) bzw. "L is not defined" (Chrome) — was die
 * Karten-Seiten als komplett weiße Seite enden ließ.
 *
 * Dieses Modul wird im Entry (main.tsx) importiert, BEVOR überhaupt eine Route lädt.
 * Damit ist `window.L` garantiert gesetzt, bevor ein Lazy-Karten-Chunk (mit den
 * Plugins) ausgewertet wird. Wichtig: Innerhalb eines einzelnen Chunks ordnet Rollup
 * die Imports um — die Plugin-Imports landen teils VOR Leaflet —, deshalb lässt sich
 * die Reihenfolge dort nicht erzwingen; nur die Dynamic-Import-Grenze (Lazy-Route) ist
 * ein verlässlicher Sequenzpunkt.
 */
if (typeof window !== "undefined") {
  (window as unknown as { L?: typeof L }).L = L;
}

export default L;
